import { motion } from "framer-motion";
import { Reveal } from "../shared/Reveal";
import CTAButton from "../shared/CTAButton";
import { FINAL_CTA } from "../../data/homeContent";
import { useI18n } from "../../i18n";
import { SITE } from "../../data/site";

export default function FinalCTA() {
  const { t } = useI18n();
  return (
    <section className="relative bg-surface py-24 md:py-36 overflow-hidden grain" data-testid="final-cta">
      <motion.div
        aria-hidden="true"
        className="absolute -top-1/4 -right-24 w-[520px] h-[520px] rounded-full bg-accent/10 blur-3xl"
        initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 1.2 }}
      />
      <div className="container-psv relative">
        <Reveal className="max-w-3xl">
          <span className="eyebrow mb-5 block">{FINAL_CTA.eyebrow}</span>
          <h2 className="font-serif font-medium text-primary text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight">
            {FINAL_CTA.heading}
          </h2>
          <p className="mt-7 text-lg md:text-xl text-secondary-foreground font-light leading-relaxed">
            {FINAL_CTA.text}
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <CTAButton to="/#case-review" size="lg" testId="final-case-review-btn">{t("cta.caseReview")}</CTAButton>
            <CTAButton href={SITE.whatsappHref} target="_blank" rel="noopener noreferrer" size="lg" variant="outline" testId="final-talk-btn">
              {t("cta.talk")}
            </CTAButton>
          </div>
          <ul className="mt-10 flex flex-wrap gap-x-8 gap-y-2">
            {FINAL_CTA.trust.map((tp) => (
              <li key={tp} className="flex items-center gap-2 text-sm text-primary/75 font-sans">
                <span className="w-1.5 h-1.5 rounded-full bg-accent" /> {tp}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
